import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center bulk_edit_header" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "bulk_edit_controls"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "panel panel-warning bulk_edit_panel" }
const _hoisted_8 = { class: "panel-heading" }
const _hoisted_9 = { class: "panel-title" }
const _hoisted_10 = { class: "panel-body" }
const _hoisted_11 = { class: "panel-footer" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["id", "onClick"]
const _hoisted_14 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!
  const _component_job_list_scm_status = _resolveComponent("job-list-scm-status")!
  const _component_btn = _resolveComponent("btn")!
  const _component_job_list_scm_actions = _resolveComponent("job-list-scm-actions")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_create_new_job_button = _resolveComponent("create-new-job-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ui_socket, {
          section: "job-list-page",
          location: "card-header"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showControls)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ui_socket, {
                section: "job-list-page",
                location: "status-item"
              }),
              _createVNode(_component_job_list_scm_status, { class: "status-item" }),
              _createVNode(_component_dropdown, { id: "project_job_actions" }, {
                dropdown: _withCtx(() => [
                  (_ctx.projAuthz('create'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.jobPageStore.uploadJobHref()
                          }, [
                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "glyphicon glyphicon-upload" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("upload.definition.button.label")), 1)
                          ], 8, _hoisted_5)
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("li", { class: "divider" }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      id: "project_job_actions_bulk_edit",
                      role: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jobPageStore.bulkEditMode = !_ctx.jobPageStore.bulkEditMode))
                    }, _toDisplayString(_ctx.$t(
                    _ctx.jobPageStore.bulkEditMode
                      ? "job.bulk.deactivate.menu.label"
                      : "job.bulk.activate.menu.label",
                  )), 1)
                  ]),
                  _createVNode(_component_job_list_scm_actions),
                  _createVNode(_component_ui_socket, {
                    location: "job-list-actions-menu",
                    section: "extended"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_btn, { class: "dropdown-toggle mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("job.actions")) + " ", 1),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "caret" }, null, -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ui_socket, {
                section: "job-list-page",
                location: "action-buttons"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_create_new_job_button)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.jobPageStore.bulkEditMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_btn, {
                class: "close",
                "aria-hidden": "true",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jobPageStore.bulkEditMode = false))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("× ", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("job.bulk.panel.select.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_btn, {
                id: "bulk_select_all_button",
                "data-testid": "job-bulk-edit-select-all-button",
                size: "xs",
                type: "default",
                class: "btn-simple btn-hover",
                onClick: _ctx.selectAll
              }, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("b", { class: "glyphicon glyphicon-check" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("select.all")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_btn, {
                id: "bulk_select_none_button",
                "data-testid": "job-bulk-edit-select-none-button",
                size: "xs",
                type: "default",
                class: "btn-simple btn-hover",
                onClick: _ctx.selectNone
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("b", { class: "glyphicon glyphicon-unchecked" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("select.none")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("job.bulk.panel.select.message", _ctx.jobPageStore.selectedJobs.length)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_dropdown, null, {
                dropdown: _withCtx(() => [
                  (_ctx.projAuthz('delete'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _createElementVNode("a", {
                          id: "bulk_delete_jobs_action",
                          role: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bulkAction('delete')))
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("b", { class: "glyphicon glyphicon-remove-circle" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("delete.selected.jobs")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _cache[13] || (_cache[13] = _createElementVNode("li", { class: "divider" }, null, -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['enable', 'disable'], (action) => {
                    return _createElementVNode("li", { key: action }, [
                      _createElementVNode("a", {
                        id: `bulk_${action}_schedules_action`,
                        role: "button",
                        onClick: ($event: any) => (_ctx.bulkAction(`${action}_schedule`))
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass(["glyphicon", 
                    action === 'enable'
                      ? 'glyphicon-check'
                      : 'glyphicon-unchecked'
                  ])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`job.bulk.${action}_schedule.button`)), 1)
                      ], 8, _hoisted_13)
                    ])
                  }), 64)),
                  _cache[14] || (_cache[14] = _createElementVNode("li", { class: "divider" }, null, -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['enable', 'disable'], (action) => {
                    return _createElementVNode("li", { key: action }, [
                      _createElementVNode("a", {
                        id: `bulk_${action}_execution_action`,
                        role: "button",
                        onClick: ($event: any) => (_ctx.bulkAction(`${action}_execution`))
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass(["glyphicon", 
                    action === 'enable'
                      ? 'glyphicon-check'
                      : 'glyphicon-unchecked'
                  ])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`job.bulk.${action}_execution.button`)), 1)
                      ], 8, _hoisted_14)
                    ])
                  }), 64)),
                  _createVNode(_component_ui_socket, {
                    section: "job-list-page",
                    location: "bulk-actions-menu"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_btn, {
                    id: "bulk_perform_action_button",
                    size: "sm",
                    class: "dropdown-toggle",
                    disabled: _ctx.jobPageStore.selectedJobs.length < 1
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("job.bulk.perform.action.menu.label")) + " ", 1),
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "caret" }, null, -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      id: "bulk_confirm_modal",
      ref: "bulk_confirm_modal",
      modelValue: _ctx.bulkConfirm,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bulkConfirm) = $event)),
      title: _ctx.$t('job.bulk.modify.confirm.panel.title')
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_btn, {
          id: "bulk_confirm_action_no_button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bulkConfirm = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("no")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_btn, {
          id: "bulk_confirm_action_yes_button",
          type: "danger",
          disabled: _ctx.jobPageStore.selectedJobs.length < 1,
          onClick: _ctx.performBulkAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`job.bulk.${_ctx.bulkConfirmAction}.button`)), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`job.bulk.${_ctx.bulkConfirmAction}.confirm.message`)), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("job.bulk.panel.select.message", _ctx.jobPageStore.selectedJobs.length)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}